import { combineReducers } from '@reduxjs/toolkit';
import { reducer as indicatorReducer } from '../slices/indicator';

const rootReducer = combineReducers({
  indicator: indicatorReducer
});

export default rootReducer;
